/* ============================================================================
   LAH — O SELO ACOMPANHA A COR ESCOLHIDA
   Tema: Testes de implementacao (7.0)

   Mostra e esconde os selos do cartao conforme a bolinha de cor clicada.

   ============================================================================
   POR QUE ISSO CUSTA QUASE NADA
   ============================================================================
   Nenhuma requisicao, nenhuma consulta ao servidor: a lista de variantes de
   cada selo ja veio no HTML, num atributo. O script so compara numeros.

   UM ouvinte no documento inteiro, nao um por cartao. Numa grade de 42
   produtos isso e a diferenca entre um ouvinte e algumas centenas — e o evento
   sobe ate aqui de qualquer bolinha, de qualquer cartao.

   O arquivo carrega uma vez por pagina: o snippet o inclui em cada cartao com
   selo, mas o navegador baixa e executa so na primeira vez.

   ============================================================================
   O RAIO DA BORDA VEM DA FOTO
   ============================================================================
   O selo precisa ter o mesmo contorno da imagem sobre a qual repousa, e esse
   raio e definido pelo tema — pode mudar nas Configuracoes sem ninguem avisar.

   Em vez de repetir um numero aqui, LEMOS o raio real da foto e passamos ao
   selo. Assim ele acompanha qualquer ajuste de estilo do tema, hoje ou depois.

   Medimos uma vez por cartao, na primeira passada. O valor nao muda durante a
   visita, e reler a cada clique seria trabalho de layout sem motivo.
   ============================================================================ */

(function () {
    'use strict';

    var TODAS = 'todas';

    /* ---------------------------------------------------------------------
       RAIO DA FOTO
       --------------------------------------------------------------------- */
    function herdarRaio() {
        var cartoes = document.querySelectorAll('.product-item__image-wrapper');

        Array.prototype.forEach.call(cartoes, function (wrap) {
            if (!wrap.querySelector('.lah-selo-foto')) return;
            if (wrap.hasAttribute('data-lah-raio')) return;

            var foto = wrap.querySelector('.product-item__aspect-ratio') ||
                       wrap.querySelector('img');

            if (!foto) return;

            var raio = getComputedStyle(foto).borderTopLeftRadius;

            /* Foto de canto reto: o selo mantem o proprio arredondamento
               discreto, definido no CSS. */
            if (raio && parseFloat(raio) > 0) {
                wrap.style.setProperty('--lah-selo-raio', raio);
            }

            wrap.setAttribute('data-lah-raio', '1');
        });
    }

    /* ---------------------------------------------------------------------
       TROCA DE COR
       --------------------------------------------------------------------- */
    function atualizar(cartao, variantId) {
        var selos = cartao.querySelectorAll('.lah-selo-foto');

        Array.prototype.forEach.call(selos, function (selo) {
            var alvo = selo.getAttribute('data-lah-selo') || '';

            /* Selo do produto inteiro: nunca se esconde. */
            if (alvo === TODAS) {
                selo.hidden = false;
                return;
            }

            /* Comparamos com virgulas nas pontas para nao confundir "123" com
               "1234" — ids de variante compartilham prefixos com frequencia. */
            var lista = ',' + alvo + ',';
            selo.hidden = lista.indexOf(',' + variantId + ',') === -1;
        });
    }

    document.addEventListener('change', function (event) {
        var radio = event.target;
        if (!radio.classList || !radio.classList.contains('color-swatch__radio')) return;

        var cartao = radio.closest('product-item');
        if (!cartao) return;
        if (!cartao.querySelector('.lah-selo-foto')) return;

        var variantId = radio.getAttribute('data-variant-id');
        if (!variantId) return;

        atualizar(cartao, variantId);
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', herdarRaio);
    } else {
        herdarRaio();
    }
})();
